"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Stagger, StaggerItem } from "@/components/shared/motion";
import { Sparkles, SmartphoneNfc, PhoneCall, LifeBuoy } from "lucide-react";

/**
 * WanderLite benefits — four simple, beginner-safe reassurance cards. Soft
 * white rounded cards, pastel icon chips. No unverifiable claims.
 */
export default function Benefits() {
  const { t } = useTranslations();

  const benefits = [
    {
      icon: Sparkles,
      title: t("wander.benefits.b1Title", "Beginner friendly"),
      body: t("wander.benefits.b1Body", "Clear steps and plain language — no tech jargon to figure out."),
    },
    {
      icon: SmartphoneNfc,
      title: t("wander.benefits.b2Title", "No physical SIM"),
      body: t("wander.benefits.b2Body", "It's all digital — nothing to swap, lose, or wait for in the mail."),
    },
    {
      icon: PhoneCall,
      title: t("wander.benefits.b3Title", "Keep your number"),
      body: t("wander.benefits.b3Body", "Your home number stays active for calls and texts while you travel."),
    },
    {
      icon: LifeBuoy,
      title: t("wander.benefits.b4Title", "Support if you need help"),
      body: t("wander.benefits.b4Body", "Stuck on a step? Friendly help is here whenever you need it."),
    },
  ];

  return (
    <section className="container mx-auto px-4 py-10">
      <Stagger as="div" className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" staggerChildren={0.08}>
        {benefits.map(({ icon: Icon, title, body }) => (
          <StaggerItem as="div" key={title} y={14} className="wander-card flex flex-col gap-3 p-6 transition-all hover:-translate-y-1 hover:border-primary/30">
            <span className="wander-chip inline-flex h-12 w-12 items-center justify-center">
              <Icon className="h-5 w-5" />
            </span>
            <div className="font-semibold text-foreground">{title}</div>
            <p className="text-sm text-muted-foreground">{body}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
